<template>
  <v-app id="inspire" class="gb chat-page">
    <div class="header-container" style="display: none !important;">
      <div class="module-container">
        <site-header-chat v-if="owner_id"/>
      </div>
    </div>
    <connection-banner/>
    <div
        v-bind:class="{
				'module-container custom-top': this.$route.path.search('/chat') === -1 && this.$route.path.search('/terms_and_conditions') === -1 && this.$route.path.search('/privacy') === -1 && this.$route.path.search('/home-files') === -1
			}"
        style="flex: 1; display: flex; flex-direction: column; min-height: 0; height: 100%;"
    >
      <router-view/>
    </div>
    <!-- Preloading handled by v-show on chat-room -->
    <free-tier-agreement-modal v-if="should_show_free_tier_modal" />
  </v-app>
</template>

<script lang="ts">
  import SiteHeaderChat from '@/components/layout/SiteHeaderChat.vue';
  import ConnectionBanner from '@/components/nav/ConnectionBanner.vue';
  import FreeTierAgreementModal from '@/components/legal/free_tier_agreement_modal.vue';
  import config from '@/config/constants.js';
  import {firestore} from "@/config/firebase";
  import {mapState} from "vuex";
  export default {
    name: 'Web',
    components: {
      'site-header-chat': SiteHeaderChat,
      'connection-banner': ConnectionBanner,
      'free-tier-agreement-modal': FreeTierAgreementModal,
    },
    data() {
      return {
        suscriptions: []
      }
    },
    watch: {
      logged(val) {
        if (val) {
          this.unsubscribe();
          this.init();
        } else {
          this.unsubscribe();
        }
        this.$nextTick(() => this.applyWrapStyles());
      },
      '$route'() {
        this.$nextTick(() => this.applyWrapStyles());
      },
    },
    created() {
      this.$store.dispatch('Connection/startListening');
      if (this.logged) {
        this.init();
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.applyWrapStyles();
      });
    },
    computed: {
      ...mapState({
        owner_id: state => state.Chat.owner_id,
        logged: state => state.Chat.logged,
        preloading: state => state.Chat.preloading,
        auth_user: state => state.Authenticate.user
      }),
      // Mirror of Web.vue's should_show_free_tier_modal — owners on a
      // legacy free tenant (tenant.pricing_mode === 'free' merged onto
      // user via getUser jsonConcat) get the one-time popup until they
      // accept config.free_terms_current_version. Lives in Chat.vue too
      // because chat-only sessions never traverse Web.vue's tree.
      should_show_free_tier_modal() {
        const user = this.auth_user;
        if (!user) return false;
        if (user.user_role !== 'owner') return false;
        if (user.pricing_mode !== 'free') return false;
        if (user.free_terms_accepted_version === config.free_terms_current_version) return false;
        return true;
      }
    },
    methods: {
      applyWrapStyles() {
        const wrap = this.$el.querySelector('.v-application--wrap');
        if (!wrap) return;
        const path = this.$route && this.$route.path || '';
        const isScrollablePage = !this.owner_id || path.includes('/chat/qr') || path.includes('/home-files');
        if (!isScrollablePage) {
          // Logged in on chat — lock viewport
          wrap.style.setProperty('padding-bottom', '0', 'important');
          wrap.style.setProperty('min-height', '100vh', 'important');
          wrap.style.setProperty('max-height', '100vh', 'important');
          wrap.style.setProperty('overflow', 'hidden', 'important');
        } else {
          // QR page, home-files, or not logged in — allow scrolling
          wrap.style.cssText = '';
        }
      },
      init() {
        const self = this;
        const tenantId = self.$store.state.Chat.tenant_id;
        const userDoc = self.$store.state.Chat.user_doc;

        if (!self.owner_id) return;

        // Listen for global user doc changes (tenants_list status)
        self.suscriptions.push(
          firestore.collection("users").doc(self.owner_id)
            .onSnapshot(doc => {
              if (doc.exists) {
                const user = doc.data();
                self.$store.commit("Chat/updateLogged", user);
                const tenant = (user.tenants_list || []).find(x => x.tenant_id === tenantId && x.status === "inactive");
                if (tenant) {
                  self.$store.commit("Authenticate/logout");
                }
              }
            }, error => {
              console.error('[Chat] Global user listener error:', error);
            })
        );

        // Listen for tenant user doc changes (is_active, disabled_by_agent_owner)
        if (userDoc && userDoc !== tenantId) {
          self.suscriptions.push(
            firestore.collection("tenants").doc(tenantId).collection("users").doc(userDoc)
              .onSnapshot(doc => {
                if (doc.exists) {
                  const user = doc.data();
                  if (user.is_active === false || user.disabled_by_agent_owner === true) {
                    self.$store.commit("Authenticate/logout");
                  }
                }
              }, error => {
                console.error('[Chat] Tenant user listener error:', error);
              })
          );
        }
      },
      unsubscribe() {
        for (const suscription of this.suscriptions) {
          if (typeof suscription === 'function') suscription();
        }
        this.suscriptions = [];
      },
    }
  };
</script>

<style lang="scss">
  @import 'assets/css/style.scss';
  @import 'assets/css/app.scss';
</style>

<style lang="scss">
  .banner-container {
    /*padding-top: 113px;*/
  }

  .v-content,
  .v-main {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    min-height: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;

    &.gb,
    .page,
    &.page {
      padding-top: 0 !important;
    }
  }

  /* Chat page: override global module-container scale and header-container height */
  .chat-page {
    .header-container {
      height: auto !important;
      z-index: 10;
    }

    .header-container > .module-container {
      transform: none !important;
      -webkit-transform: none !important;
      -moz-transform: none !important;
    }

    .v-footer, .app-footer {
      display: none !important;
    }

    .v-main:not(.qr-container) {
      max-height: 100vh;
      overflow: hidden;
    }

    .v-main__wrap,
    .v-application--wrap {
      min-height: 100vh !important;
      max-height: 100vh !important;
    }

    /* QR page must scroll */
    .v-main.qr-container {
      max-height: none !important;
      overflow: visible !important;
      height: auto !important;
    }
  }

  /* Override ALL scroll-blocking ancestors when QR page or home-files is shown */
  .chat-page:has(.qr-container),
  .chat-page:has(.hf) {
    overflow: auto !important;
    max-height: none !important;
    height: auto !important;
  }
  .chat-page:has(.qr-container) .v-application--wrap,
  .chat-page:has(.hf) .v-application--wrap {
    max-height: none !important;
    overflow: visible !important;
    min-height: auto !important;
  }
  .chat-page:has(.qr-container) .v-main,
  .chat-page:has(.hf) .v-main {
    max-height: none !important;
    overflow: visible !important;
  }
</style>
